var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9325 12.8851C2.79 12.8851 2.6475 12.8326 2.535 12.7201C1.5075 11.6851 0.9375 10.3201 0.9375 8.87258C0.9375 5.86508 3.375 3.42006 6.375 3.42006L10.9275 3.43508L10.11 2.65505C9.885 2.43755 9.87751 2.08505 10.095 1.86005C10.3125 1.63505 10.665 1.62758 10.89 1.84508L12.72 3.60006C12.885 3.75756 12.9375 4.00506 12.855 4.21506C12.7725 4.42506 12.5625 4.56759 12.33 4.56759L6.3675 4.55257C3.99 4.55257 2.055 6.49509 2.055 8.88009C2.055 10.0276 2.50499 11.115 3.32249 11.9325C3.53999 12.15 3.53999 12.51 3.32249 12.7275C3.21749 12.8325 3.075 12.8851 2.9325 12.8851Z",
    fill: "#E60A2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49993 16.3125C7.35743 16.3125 7.22242 16.26 7.10992 16.155L5.27992 14.4C5.11492 14.2425 5.06243 13.995 5.14493 13.785C5.22743 13.575 5.43742 13.4325 5.66992 13.4325L11.6324 13.4475C14.0099 13.4475 15.9449 11.505 15.9449 9.11996C15.9449 7.97246 15.4949 6.885 14.6774 6.0675C14.4599 5.85 14.4599 5.49 14.6774 5.2725C14.8949 5.055 15.2549 5.055 15.4724 5.2725C16.4999 6.3075 17.0699 7.67246 17.0699 9.11996C17.0699 12.1275 14.6324 14.5725 11.6324 14.5725L7.07993 14.5575L7.89743 15.3375C8.12243 15.555 8.12993 15.9075 7.91243 16.1325C7.79243 16.2525 7.64993 16.3125 7.49993 16.3125Z",
    fill: "#E60A2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9.5625H6.75C6.4425 9.5625 6.1875 9.3075 6.1875 9C6.1875 8.6925 6.4425 8.4375 6.75 8.4375H11.25C11.5575 8.4375 11.8125 8.6925 11.8125 9C11.8125 9.3075 11.5575 9.5625 11.25 9.5625Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.84796ecf49e80ed41c1429c1986cb6a6.svg";
export { ForwardRef as ReactComponent };